import type { ProductCard as ProductCardType } from '@lib/types'

import PrismicLink from '@components/PrismicLink'
import ProductOrCollectionCard from '@components/products/ProductOrCollectionCard'

interface Props {
	slice: any
}

export default function ProductsSlider({ slice }: Props) {
	// console.log('ProductsSlider Slice ->', slice)
	const { primary, items } = slice
	return (
		<section className="products-slider section">
			<div className="container flex flex-col items-center">
				{/* Title */}
				{primary.section_title?.[0] && (
					<h2 className="text-4xl text-center title">{primary.section_title[0].text}</h2>
				)}
				{/* Description */}
				{/* TODO: Make richtext component */}
				{primary.section_description?.[0] && (
					<p className="text-center subtitle">{primary.section_description[0].text}</p>
				)}
				{/* TODO: Insert product cards for this data here */}
				<div className="grid grid-cols-1 my-12 sm:grid-cols-2 md:grid-cols-4">
					{items.map((product: ProductCardType) => (
						<ProductOrCollectionCard
							image={product.image}
							price={product.price}
							vendor={product.vendor}
							handle={product.handle}
							id={product.id}
							name={product.name}
							key={product.id}
							avgRating={product.avgRating}
							numReviews={product.numReviews}
							hideFavoriteButton
							collections={product.collections}
							hasStock={product.hasStock}
						/>
					))}
				</div>
				{primary?.section_cta && (
					<PrismicLink
						link={primary.section_cta}
						label={primary.section_cta_label || 'Get Started'}
						className="button button-secondary"
					/>
				)}
			</div>
		</section>
	)
}
